/* eslint-disable max-len */
/* eslint-disable indent */
import React, { useState } from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'

import icChevronDown from '../../static/icons/ic-chevron-down.svg'
import icChevronUp from '../../static/icons/ic-chevron-up.svg'
import imgServiceContent from '../../static/images/service-content.svg'
import imgServiceContentMobile from '../../static/images/service-content-mobile.svg'
import { TitleOne, TextBodyOne } from '../text'
import serviceContentConstant from '../../constants/service-content'
import { Style } from './index.styles'

const { serviceContent } = serviceContentConstant

const renderTitle = ({ content }) => (
  <TitleOne className="title-service-content" display="block">
    {serviceContent[content].title}
  </TitleOne>
)

const renderSubtitle = ({ content }) =>
  serviceContent[content].subtitle.map((item, index) => (
    <TextBodyOne
      key={index}
      className="subtitle-service-content"
      display="block"
    >
      {item}
    </TextBodyOne>
  ))

const renderDetailContent = ({ content }) =>
  serviceContent[content].detailContent.map(item => (
    <div key={item.id} className="detail-content">
      <TitleOne className="title-service-content" display="block">
        {item.title}
      </TitleOne>
      {item.subtitle.map(itemSubtitle => (
        <TextBodyOne
          key={itemSubtitle}
          className="subtitle-service-content"
          display="block"
        >
          {itemSubtitle}
        </TextBodyOne>
      ))}
      {item.subDetailContent.map(itemSubDetailContent => (
        <ul key={itemSubDetailContent.id}>
          {itemSubDetailContent.title && (
            <li>
              <TitleOne className="title-service-content" display="block">
                {itemSubDetailContent.title}
              </TitleOne>
            </li>
          )}
          {itemSubDetailContent.title
            ? itemSubDetailContent.subtitle.map(
              itemSubDetailContentSubtitle => (
                <TextBodyOne
                  key={itemSubDetailContentSubtitle}
                  className="subtitle-service-content"
                  display="block"
                >
                  {itemSubDetailContentSubtitle}
                </TextBodyOne>
              )
            )
            : itemSubDetailContent.subtitle.map(
              itemSubDetailContentSubtitle => (
                <li key={itemSubDetailContentSubtitle}>
                  <TextBodyOne
                    className="subtitle-service-content"
                    display="block"
                  >
                    {itemSubDetailContentSubtitle}
                  </TextBodyOne>
                </li>
              )
            )}
        </ul>
      ))}
      {item.footer &&
        item.footer.map(footerItem => (
          <TextBodyOne
            key={footerItem}
            className="subtitle-service-content"
            display="block"
          >
            {footerItem}
          </TextBodyOne>
        ))}
    </div>
  ))

const renderFooter = ({ content }) =>
  serviceContent[content].footer && (
    <TextBodyOne className="subtitle-service-content" display="block">
      {serviceContent[content].footer}
    </TextBodyOne>
  )

const renderLinks = ({ content }) =>
  serviceContent[content].links && (
    <div className="detail-content-link">
      <TitleOne className="title-service-content" display="block">
        {serviceContent[content].links.title}
      </TitleOne>
      <p className="p-link">
        {serviceContent[content].links.detailLinks.map((itemLink, index) => (
          <>
            <a key={itemLink.id} href={itemLink.link} className="link">
              {itemLink.title}
            </a>
            {index !== serviceContent[content].links.detailLinks.length - 1 && (
              <span> | </span>
            )}
          </>
        ))}
      </p>
    </div>
  )

const renderButtonShowDetailContent = (
  showDetailContent,
  setShowDetailContent
) => (
  <div
    className="container-read-more"
    onClick={() => setShowDetailContent(!showDetailContent)}
  >
    <TextBodyOne className="read-more-text" display="block">
      {showDetailContent ? 'Baca Lebih Sedikit' : 'Baca Selengkapnya'}
    </TextBodyOne>
    <img
      className="check"
      src={showDetailContent ? icChevronUp : icChevronDown}
      alt="halojasa/service-content-icon"
      loading="lazy"
    />
  </div>
)

const renderShowDetailContent = props => (
  <>
    {renderDetailContent(props)}
    {renderFooter(props)}
    {renderLinks(props)}
  </>
)

const renderImageServiceContent = ({ isWeb = true }) => (
  <div className="container-image-service-content">
    <img
      className="check"
      src={isWeb ? imgServiceContent : imgServiceContentMobile}
      alt="halojasa/service-content-image"
      loading="lazy"
    />
  </div>
)

const ServiceContent = props => {
  const [showDetailContent, setShowDetailContent] = useState(false)

  return (
    <Style>
      <Grid>
        <Row>
          <Col sm={12} xs={12} lg={12} className="container-service-content">
            {renderTitle(props)}
            {renderSubtitle(props)}
            {showDetailContent && renderShowDetailContent(props)}
            {renderButtonShowDetailContent(
              showDetailContent,
              setShowDetailContent
            )}
            {renderImageServiceContent(props)}
          </Col>
        </Row>
      </Grid>
    </Style>
  )
}

export default ServiceContent
